import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/apiService/api.service';
import { AuthServiceService } from 'src/app/services/authService/auth-service.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { BookingDatalayerService } from 'src/app/services/dataLayer/booking-datalayer.service';
import { GlobalAmenitiesService } from 'src/app/services/global-amenities.service';
import { HomeHeadingContianerComponent } from '../home-heading-contianer/home-heading-contianer.component';
import { ProfileStripSummaryComponent } from '../profile-strip-summary/profile-strip-summary.component';
import { NgIf } from '@angular/common';
import { BookingTabLayoutComponent } from '../../../search-engine/components/booking-tab-layout/booking-tab-layout.component';
import { TravelComfortComponent } from '../travel-comfort/travel-comfort.component';
import { ToastMessageComponent } from 'src/app/shared/components/toast-message/toast-message.component';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';

@Component({
  selector: 'app-dasboard-tab-layout',
  templateUrl: './dasboard-tab-layout.component.html',
  styleUrls: ['./dasboard-tab-layout.component.scss'],
  imports: [HomeHeadingContianerComponent, ProfileStripSummaryComponent, NgIf, BookingTabLayoutComponent, TravelComfortComponent, ToastMessageComponent]
})
export class DasboardTabLayoutComponent implements OnInit {
  LocalSessionStorage = LocalSessionStorage;
  isMultiCity: boolean = false
  triptype: string = '1'
  firstLoginToaster:boolean=false
  constructor(private authService: AuthServiceService, private _ApiService: ApiService, private _bookingDatalayer: BookingDatalayerService, private globalAmenities: GlobalAmenitiesService, private readonly router: Router, private _camService: CamService) {
    this.authService.getToken().subscribe((res) => {
      localStorage.setItem('token_type', res.data.token_type);
      localStorage.setItem('access_token', res.data.access_token);
      localStorage.setItem('expires_in', res.data.expires_in.toString()); // Store as string
      localStorage.setItem('session_id', res.data.session_id);
      localStorage.setItem('scope', res.data.scope);
    })
  }
  ngOnInit() {
    sessionStorage.removeItem("viaImageCardOpenControls");
    sessionStorage.removeItem('ptPtotalExtraPrice');
    sessionStorage.removeItem('orderDetail');
    localStorage.removeItem('isMmbFlow');
    sessionStorage.removeItem('flightDetailLabel');
    sessionStorage.removeItem('segmentWisePrice');
    sessionStorage.removeItem('multicityFlightLabel');
    sessionStorage.removeItem('multicityFlightCabinType');
    sessionStorage.removeItem('reissuesSelectedFlightClas');
    // this.getGeoLocation();
    this.GetAmenitiesAll();
    this.GetAirlinesAll();
    this._bookingDatalayer.page_landing('', 'Dashboard')// GTM use
    localStorage.removeItem('isMmbflow');
    localStorage.removeItem('gtmDistAmtBkAnlyAplyPc');
    sessionStorage.removeItem('selectedFlightClass');
    const QlAccessToken = localStorage.getItem('QlAccessToken') || '';
    const decoded: any = jwtDecode(QlAccessToken);
    this.firstLoginToaster = decoded?.IsFirstLogin === true || decoded?.IsFirstLogin === 'true';
    this._camService.getCompanySetting().then((companyRes: any) => {
      if (companyRes?.status === 'Success' && companyRes?.data) {
        const companySettingsJson = JSON.stringify(companyRes?.data);
        localStorage.setItem(this.LocalSessionStorage.COMPANY_SETTINGS, companySettingsJson);
        sessionStorage.setItem(this.LocalSessionStorage.COMPANY_SETTINGS, companySettingsJson);
      }
    }).catch(() => {
      // Non-blocking: navigate even if company settings fail
    })
  }
  getGeoLocation() {
    this._ApiService.GetGeoLocation().then(($: any) => {
      localStorage.setItem("CountryCode", $ ?? "IN");
    })
  }

  handleTripTypeChange(isMultiCity: boolean) {
    this.isMultiCity = isMultiCity;
    // You can perform additional actions based on the trip type if needed
  }
  handleOWRTTypeChange(isTripType: string) {
    this.isMultiCity = false;
    this.triptype = isTripType;
    // You can perform additional actions based on the trip type if needed
  }
  GetAmenitiesAll() {
    this._ApiService.getAmenities()
      .then((res: any) => {

        this.globalAmenities.setAmenities(res);
        console.log('Amenities API:', res);
      })
      .catch(err => {
        console.error('Amenities API failed, falling back to local JSON', err);
        fetch('assets/jsonData/getAmenities.json')
          .then(response => response.json())
          .then(localData => {
            this.globalAmenities.setAmenities(localData);
            console.log('Amenities local data loaded:', localData);
          })
          .catch(localErr => console.error('Failed to load local amenities data', localErr));
      });
  }

  GetAirlinesAll() {
    this._ApiService.getAirlines()
      .then((res: any) => {
        sessionStorage.setItem('airlinesData', JSON.stringify(res));
        console.log('Airlines API:', res);
      })
      .catch(err => {
        console.error('Airlines API failed, falling back to local JSON', err);
        fetch('assets/jsonData/getAirlines.json')
          .then(response => response.json())
          .then(localData => {
            sessionStorage.setItem('airlinesData', JSON.stringify(localData));
            console.log('Airlines local data loaded:', localData);
          })
          .catch(localErr => console.error('Failed to load local airlines data', localErr));
      });
  }

  handleEnableIDP() {
    this.router.navigate(['/cam/other-misc-func/enable-company-login'])
  }

}
